'use strict'
// import '@babel/polyfill'
import axios from 'axios'
import store from '@/store'
import ConstCode from '@/common/constants/ConstCode'
import Util from '@/common/utils/Util'
import queryString from 'query-string'
import router from '@/router'
// import $_ from 'lodash'
let _this = null
const loadingMinDuration = 300
class ServiceExec {
  constructor () {
    // this.enhanceAccessToeken()
    let ServiceExec = axios.create({
      headers: {csrf: 'ownerAppMap'},
      withCredentials: true,
    })
    // setLoading
    ServiceExec.interceptors.request.use(this.handleRequest)
    ServiceExec.interceptors.response.use(this.handleSuccess, this.handleError)
    this.ServiceExec = ServiceExec
    this.ConstCode = ConstCode
    this.store = store
    this.router = router
    this.axios = axios
    _this = this
  }

  storeSetLoading (isLoading) {
    store.commit('layout/setLoading', {isLoading: isLoading})
  }

  handleRequest (request) {
    _this.storeSetLoading(true)

    // 현재 설정한 언어 헤더에 전송
    if (!Util.isEmpty(store)) {
      const accessToken = store.getters['account/getAccessToken']
      if (!accessToken) return request
      request.headers.common['user_login_token'] = `${accessToken}`
    }

    return request
  }

  handleSuccess (response) {
    setTimeout(() => {
      _this.storeSetLoading(false)
    }, loadingMinDuration)
    return response
  }

  async refreshAdminToken (adminData) {
    const params = {}
    params.adminNo = adminData.adminNo
    const res = await _this.queryPost('/easy-admin/admin/changeToken', params)
    let authToken = res.headers['codd_jwt_admin_token']
    adminData = res.data.entity
    if (!Util.isEmpty(authToken)) {
      store.commit('admin/storeLogin', {accessToken: authToken, adminData: JSON.stringify(adminData)})
      return true
    } else {
      store.commit('admin/storeLogout')
      return false
    }
  }

  async handleError (error) {
    // _this.storeSetLoading(false)
    // const adminData = store.getters['admin/getAdminData']
    // switch (error.response.status) {
    //   case 401: // 권한 차단
    //     store.commit('admin/storeLogout')
    //     _this.router.push('/account/login')
    //     break;
    //   case 402: // 비로그인시 차단
    //     store.commit('admin/storeLogout')
    //     _this.router.push('/account/login')
    //     break;
    //   case 403: // expireDate 체크 -> 토큰 재발급
    //     if (!await _this.refreshAdminToken(adminData)) {
    //       return false
    //     }
    //     error.config.headers.Authorization = store.getters['admin/getAccessToken']
    //     return _this.axios.request(error.config)
    //   case 404:
    //     // alert('서버와 통신이 원활하지 않습니다.')
    //     store.commit('layout/setModal', {modalName: 'modal-error-service', callBack : () => {
    //         console.log('@@@@@')
    //         setTimeout(() => { location.reload() }, 1)
    //       }
    //     })
    //     break
    //   default:
    //     // alert('서버와 통신이 원활하지 않습니다.')
    //     store.commit('layout/setModal', {modalName: 'modal-error-service', callBack : () => {
    //         console.log('@@@@@')
    //         setTimeout(() => { location.reload() }, 1)
    //       }
    //     })
    //     break
    // }
    return Promise.reject(error)
  }

  get (path, params = {}) {
    return this.ServiceExec.get(path, {params})
  }

  patch (path, payload) {
    return this.ServiceExec.request({
      method: 'PATCH',
      url: path,
      responseType: 'json',
      data: payload
    })
  }

  post (path, payload) {
    return this.ServiceExec.request({
      method: 'POST',
      url: path,
      responseType: 'json',
      data: payload
    })
  }

  queryPost (path, payload) {
    payload = `${queryString.stringify(payload)}`
    return this.ServiceExec.request({
      method: 'POST',
      url: path,
      responseType: 'json',
      data: payload
    })
  }

  queryMultiPost (path, payload) {
    payload = `${queryString.stringify(payload)}`
    return this.ServiceExec.request({
      headers: {'Content-Type': 'multipart/form-data'},
      method: 'POST',
      url: path,
      responseType: 'json',
      data: payload
    })
  }

  multiPost (path, payload) {
    return this.ServiceExec.request({
      headers: {'Content-Type': 'multipart/form-data'},
      method: 'POST',
      url: path,
      responseType: 'json',
      data: payload
    })
  }

  enhanceAccessToeken () {
    let accessToken = ''
    if (!Util.isEmpty(store)) {
      accessToken = store.getters['admin/getAccessToken']
    }
    console.log('여기서 체크 1 :: ',accessToken)
    if (!accessToken) return
    console.log('여기서 체크 2 :: ',accessToken)
    axios.defaults.headers.common['Authorization'] = `${accessToken}`
  }

  delete(path, params = {}) {
    // payload = `${path}?${queryString.stringify(payload)}`
    return this.ServiceExec.delete(path, {params})
  }

  timeout = function (ms) {
    return new Promise(resolve => {setTimeout(resolve, ms)})
  }
}

export default ServiceExec
